import { Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing";
import JoinPage from "./pages/JoinPage";

export default function App() {
  return (
    <Routes>
      <Route path="/unete" element={<JoinPage />} />
      {/* Landing también resuelve las URLs históricas del sitio. */}
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
